import { OrganizationListItem } from '@shared/model/organization';

export const organizationContacts = (organization: OrganizationListItem) => {
    const manager = organization.manager;
    const phone = manager?.phoneNumber ? `тел.: ${manager.phoneNumber}` : '';
    const email = manager?.email ? `e-mail.: ${manager.email}` : '';
    const address = `Адрес: ${organization.address}`;
    return [address, phone, email].filter(Boolean).join(', ');
};
